/**
 * `Ф3` (кабинет ПЗС): называние состояния учётной записи по `ЖЦ-01`.
 * Коды приходят с сервера (`account_state`), слова — здесь, в одном месте.
 */
export const ACCOUNT_STATE_TITLES: Record<string, string> = {
  active: "активна",
  access_closed: "доступ закрыт",
  deletion_requested: "поставлена на удаление",
  pending: "приглашён",
  blocked: "заблокирована",
  cancelled: "аннулирована",
  anonymized: "обезличена",
};

export function accountStateTitle(state?: string | null): string {
  return ACCOUNT_STATE_TITLES[String(state || "active")] || "—";
}
